// removed by extract-text-webpack-plugin
module.exports = {"main-container":"_2PKqkoUyyWO2RIC16q3je6","box-picture-container":"LTBgtK7r1nOvC5NICnHeh","box-content-container":"_1xGcQZJGuDqCot7tMQ23Ln","box-picture-bg":"wnG3AHFwEKg_kMMtNpLV1","triangle":"_1hna0Dm7dVtfukMimmqjmX","btn-container":"qWdi_RM_Lekp7IG2btZLU","btn-chat":"_2zbcyP5tujs_kXBoscklhO","free":"SYfMc1hjk-a0DO_9Crzjt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Customize/CustomizeBox.scss
// module id = 248
// module chunks = 0 1 14